import React from "react";
import colors from "./colors";

const Intro = () => {
  return (
    <div className="text-center mx-auto md:mx-40 my-20">
      <h1 className={`text-5xl ${colors.TEXT_COLOR} font-mono`}>What we do</h1>
      <p className="text-xl p-7">
        We specialize in helping businesses of all sizes effectively reach their
        target audience and achieve their marketing goals through the use of
        Facebook and its suite of tools. Our team of experts has a deep
        understanding of how to use Facebook's algorithms and ad targeting
        options to deliver maximum results. With our data-driven approach, we
        have a proven track record of delivering successful campaigns for our
        clients. Let us help you take your business to the next level and reach
        your full potential on Facebook.
      </p>
    </div>
  );
};

export default Intro;
